import forEach from 'lodash/forEach';

import Magento2FormPart from './packages/Magento2/components/Magento2FormPart';
import * as Magento2FormPartUtils from './packages/Magento2/components/Magento2FormPart/utils';

export default {
    name: 'integrationsConfig',
    before: [],
    after: [],
    setup: (app) => {
        const routes = ['settingIntegrationForm'];

        forEach(routes, (routeName) => {
            const route = app.routes.getItem(routeName);
            if (route) {
                const routeProps = route.props;
                route.props = (state) => ({
                    ...routeProps(state),
                    customIntegrationComponents: {
                        magento2: Magento2FormPart,
                    },
                    customIntegrationUtils: {
                        magento2: Magento2FormPartUtils,
                    },
                });
                app.routes.changeItem(routeName, route);
            }
        });
    },
};
